import { SVGProps } from "react";

export const EntityTypeIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M6 8.58333H7.798C7.36667 8.88608 7.02867 9.28567 6.84 9.75H6V8.58333ZM16 10.625V15H8V10.625C8 9.82058 8.74733 9.16667 9.66667 9.16667H10V8.875C10 8.39258 10.4487 8 11 8H13C13.5513 8 14 8.39258 14 8.875V9.16667H14.3333C15.2527 9.16667 16 9.82058 16 10.625ZM9.33333 10.625V11.5H14.6667V10.625C14.6667 10.4646 14.5167 10.3333 14.3333 10.3333H9.66667C9.48333 10.3333 9.33333 10.4646 9.33333 10.625ZM14.6667 13.8333V12.6667H12.6667V13.25H11.3333V12.6667H9.33333V13.8333H14.6667ZM1.33333 2.75C1.33333 2.428 1.632 2.16667 2 2.16667H8.66667C9.03467 2.16667 9.33333 2.428 9.33333 2.75V7.45458C9.684 7.13958 10.146 6.92083 10.6667 6.8555V2.75C10.6667 1.78517 9.76933 1 8.66667 1H2C0.897333 1 0 1.78517 0 2.75V15H6.66667V13.8333H1.33333V2.75ZM4.66667 8.58333H2.66667V9.75H4.66667V8.58333ZM2.66667 12.0833H4.66667V10.9167H2.66667V12.0833ZM4.66667 3.91667H2.66667V5.08333H4.66667V3.91667ZM8 3.91667H6V5.08333H8V3.91667ZM4.66667 6.25H2.66667V7.41667H4.66667V6.25ZM6 7.41667H8V6.25H6V7.41667Z"
      fill="#706A85"
    />
  </svg>
);
